import React from 'react';
import styled from 'styled-components';
import { RatingElement } from '@catalogo/ui-americanas-mobile-rating';
import ProductName from '../atoms/product-name';

const ProductInfo = ({ className, rating, ...cardProps }) => (
  <Wrapper className={className}>
    <Container>
      <ProductName {...cardProps} />
      <RatingElement size={15} rating={rating} fontSize={12} hasCount={true} />
    </Container>
  </Wrapper>
);

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Container = styled.div`
  display: grid;
  gap: 8px;
`;

export default ProductInfo;
